import React from 'react';
import {
    hideAction as hideNotifyMeAction,
    setQuantityAction as setQuantityNotifyMeAction,
    setNameAction as setNameNotifyMeAction,
    setMarketingConsentAction as setMarketingConsentotifyMeAction,
    setEmailAction as setEmailNotifyMeAction,
    setPhoneAction as setPhoneNotifyMeAction,
    emailInvalidAction as emailInvalidNotifyMeAction,
    emailValidAction as emailValidNotifyMeAction,
    phoneInvalidAction as phoneInvalidNotifyMeAction,
    phoneValidAction as phoneValidNotifyMeAction,
    formSubmitAction
} from '../../_flux/actions/notify_me_actions';
import NotifyMeStore from '../../_flux/stores/notify_me_store';
import NotifyMeComponent from '../../_flux/components/notify_me/notify_me';
import EmailValidator from '../../validator/email_validator';
import API from '../../API/api';
import * as NotifyMeGoogleAnalytics from '../../_modules/google_analytics/notify_me';
import { handleView } from '../handle_view';
import PhoneValidator from '../../validator/phone_validator';

const stores = {
    notifyMeState: NotifyMeStore,
};

const render = ({ notifyMeState }) => (
    <NotifyMeComponent
        quantity={notifyMeState.quantity}
        name={notifyMeState.name}
        email={notifyMeState.email}
        phone={notifyMeState.phone}
        sku={notifyMeState.sku}
        visible={notifyMeState.visible}
        emailInvalid={notifyMeState.emailInvalid}
        phoneInvalid={notifyMeState.phoneInvalid}
        type={notifyMeState.notificationType}
        tyreQuantityOptions={notifyMeState.tyreQuantityOptions}
        isSubmitted={notifyMeState.isSubmitted}
        isError={notifyMeState.isError}
        errorMsg={notifyMeState.errorMsg}
        onChange={onNotifyMeValueChange}
        onSubmit={onNotifyMeSubmit}
        onClose={hideNotifyMeAction}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);

const onNotifyMeValueChange = (value, property) => {
    switch (property) {
        case 'name':
            setNameNotifyMeAction(value);
            break;
        case 'marketing-consent':
            setMarketingConsentotifyMeAction(value);
            break;
        case 'email':
            setEmailNotifyMeAction(value);
            break;
        case 'telephone':
            setPhoneNotifyMeAction(value);
            break;
        case 'quantity':
            setQuantityNotifyMeAction(value);
            break;

    }
};


const onNotifyMeSubmit = () => {
    const { name, quantity, email, phone, sku, marketingConsent } = NotifyMeStore.getState();

    if (!EmailValidator.validate(email)) {
        emailInvalidNotifyMeAction();
        NotifyMeGoogleAnalytics.notifyWhenProductRestockedFormSubmitFailure('E-mail invalid');
    } else if (phone && !PhoneValidator.validate(phone)) {
        phoneInvalidNotifyMeAction();
        NotifyMeGoogleAnalytics.notifyWhenProductRestockedFormSubmitFailure('Phone invalid');
    } else {
        emailValidNotifyMeAction();
        phoneValidNotifyMeAction();
        API.GET({
            apiPath: '/customer/registerforproductnotification/',
            data: {
                requestedQty: quantity,
                name,
                email,
                sku,
                marketingConsent,
                telephone: phone
            }
        }).then(() => {
            formSubmitAction();
        }).catch(e => {
            formSubmitAction({ isError: true, message: e?.responseJSON?.message || '' });
        });

        NotifyMeGoogleAnalytics.notifyWhenProductRestockedFormSubmit(sku);
    }

};
